export default async function onUserModule(ctx) {
    void ctx;
    await mountNavbarIsland();
    await mountAnnouncementIsland();
}
async function mountNavbarIsland() {
    const navbarContainer = document.getElementById('user-navbar-root');
    if (navbarContainer) {
        try {
            const { createRoot } = await import('react-dom/client');
            const UserNavbarIsland = (await import('@core/ts/components/user/UserNavbarIsland')).default;
            const React = await import('react');
            const root = createRoot(navbarContainer);
            root.render(React.createElement(UserNavbarIsland));
        }
        catch (error) {
            console.error('Failed to mount navbar island:', error);
        }
    }
}
async function mountAnnouncementIsland() {
    const container = document.getElementById('announcement-root');
    if (container) {
        try {
            const { createRoot } = await import('react-dom/client');
            const AnnouncementIsland = (await import('@core/ts/components/announcements/AnnouncementIsland')).default;
            const React = await import('react');
            const root = createRoot(container);
            root.render(React.createElement(AnnouncementIsland));
        }
        catch (error) {
            console.error('Failed to mount announcement island:', error);
        }
    }
}
